import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";

export const NotificationAutoTranlationComplete: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const completeInfo = actions[0]?.autoTranslationCompleteInfo;

    if (!completeInfo) return null;

    const autoTranslateStopped = 3;
    if (completeInfo?.autoTranslateStatus === autoTranslateStopped) {
        return <SimpleTitle>
            {` Процесс автоматического перевода Проекта `}
            <a href={CreateLinkTo.project(completeInfo?.projectId)}>
                {completeInfo?.projectTitle}
            </a>
            {` остановлен. `}
        </SimpleTitle>
    }

    return <SimpleTitle>
        {` Автоматический перевод Проекта `}
        <a href={CreateLinkTo.project(completeInfo?.projectId)}>
            {completeInfo?.projectTitle}
        </a>
        {` осуществлен. `}
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";

export const NotificationAutoTranlationComplete: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const completeInfo = actions[0]?.autoTranslationCompleteInfo;

    if (!completeInfo) return null;

    const autoTranslateStopped = 3;
    if (completeInfo?.autoTranslateStatus === autoTranslateStopped) {
        return <SimpleTitle>
            {` Процесс автоматического перевода Проекта `}
            <a href={CreateLinkTo.project(completeInfo?.projectId)}>
                {completeInfo?.projectTitle}
            </a>
            {` остановлен. `}
        </SimpleTitle>
    }

    return <SimpleTitle>
        {` Автоматический перевод Проекта `}
        <a href={CreateLinkTo.project(completeInfo?.projectId)}>
            {completeInfo?.projectTitle}
        </a>
        {` осуществлен. `}
    </SimpleTitle>
}